import { Grid } from "@mui/material";
import React from "react";

const TakeAway = () => {
  return (
    <div style={{ width: 1079, display: "flex", justifyContent: "center" }}>
      <div style={{ width: 1019, marginTop: 30 }}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          {Array.from(Array(30)).map((item, index) => (
            <SingleBox item={item} key={index} />
          ))}
        </Grid>
      </div>
    </div>
  );
};

const SingleBox = ({ item }) => (
  <div
    style={{
      background: "#1A5044",
      width: 192,
      height: 80,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: 15,
      cursor: "pointer",
    }}
  >
    <div
      style={{
        color: "#FFFFFF",
        fontSize: 18,
        fontWeight: "500",
        fontFamily: `Poppins, sans-serif`,
      }}
    >
      Take Away 01
    </div>
  </div>
);

export default TakeAway;
